import React, { useState, useEffect } from 'react';
import NoData from '../../../components/common/NoData';
import Loader from '../../../components/common/Loader';
import { Icon } from '@iconify/react';
import { getTraineeAnalytics } from '../../../services/traineeService';
import { toast } from 'react-toastify';

function TraineeAnalyticsClassroomTab({ traineeId }) {
  const [loading, setLoading] = useState(false);
  const [classroomData, setClassroomData] = useState([]);

  const fetchClassroomData = async () => {
    try {
      setLoading(true);
      const response = await getTraineeAnalytics({ trainee_id: traineeId });
      // console.log('classrooms Data:', response.data.classrooms);

      if (response.success) {
        setClassroomData(response.data.classrooms || []);
      } else {
        toast.error(response.message || 'Failed to fetch classroom data');
      }
    } catch (error) {
      console.error('Error fetching classroom data:', error);
      toast.error('Something went wrong while fetching classroom data');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (traineeId) {
      fetchClassroomData();
    }
  }, [traineeId]);

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-[220px] rounded-2xl border border-gray-100 bg-gray-50/40">
        <Loader />
      </div>
    );
  }

  if (!classroomData || classroomData.length === 0) {
    return <NoData message="No classrooms found" />;
  }

  return (
    <div className="rounded-2xl border border-gray-100 bg-white shadow-sm overflow-hidden">
      <div className="overflow-x-auto">
        <table className="min-w-[640px] w-full text-sm">
          <thead className="sticky top-0 z-10 bg-gray-50">
            <tr className="text-left text-xs font-semibold text-gray-600">
              <th className="px-4 py-3 w-[90px]">SL No.</th>
              <th className="px-4 py-3">Classroom Name</th>
              <th className="px-4 py-3 text-center w-[180px]">Total Trainees</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100">
            {classroomData.map((classroom, index) => (
              <tr key={classroom.class_id} className="hover:bg-gray-50/60 transition-colors">
                <td className="px-4 py-3 text-gray-500">{index + 1}</td>
                <td className="px-4 py-3">
                  <div className="flex items-center gap-2 min-w-0">
                    <Icon icon="fluent:people-team-24-regular" className="text-gray-400" width="18" />
                    <span className="font-medium text-gray-900 truncate">{classroom.cls_name}</span>
                  </div>
                </td>
                <td className="px-4 py-3 text-center">
                  <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-semibold bg-primary/10 text-primary border border-primary/20">
                    {classroom.total_trainees} Trainees
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default TraineeAnalyticsClassroomTab;